<template>
  <div class="page-col">
    <div class="page-main">
      <!--   -->
      <div class="list-header-premium d-flex flex-column flex-xl-row align-items-center justify-content-between gap-3 mb-4" :class="{'bg-dark border-secondary': isDark}">
        <div class="d-flex align-items-center">
          <div class="header-icon-wrapper mr-3" style="background: linear-gradient(135deg, #20a8d8 0%, #1783ae 100%);">
            <i class="fa fa-shopping-cart text-white"></i>
          </div>
          <div>
            <h4 class="mb-0 font-weight-bold" :class="isDark ? 'text-white' : 'text-dark'">Gestão de Compras</h4>
            <span class="text-muted small">Gerencie suas compras e pedidos de fornecedores</span>
          </div>
        </div>

        <div class="d-flex align-items-center gap-2">
          <!-- Filtro Consolidado Premium -->
          <div class="d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border">
            <b-button-group class="mr-1">
              <b-button variant="link" class="btn-icon-only text-muted" @click="filtro.avancado = !filtro.avancado" v-b-tooltip.hover title="Filtros Avançados">
                <i class="fa fa-filter" :class="{'text-primary': filtro.avancado}"></i>
              </b-button>
              <b-button variant="link" class="btn-icon-only text-muted" @click="exportarHtml()" v-b-tooltip.hover title="Imprimir">
                <i class="fa fa-print"></i>
              </b-button>
              <b-button variant="link" class="btn-icon-only text-muted" @click="exportarExcel()" v-b-tooltip.hover title="Excel">
                <i class="fa fa-file-excel-o"></i>
              </b-button>
              <b-button variant="link" class="btn-icon-only text-muted" @click="exportarCsv()" v-b-tooltip.hover title="CSV">
                <i class="fa fa-file-text-o"></i>
              </b-button>
              <b-button variant="link" class="btn-icon-only text-danger" @click="limpar()" v-b-tooltip.hover title="Limpar Filtros">
                <i class="fa fa-ban"></i>
              </b-button>
            </b-button-group>

            <div class="d-flex align-items-center px-2 border-left mr-1">
              <CecInputData ref="dt1" v-model="dt1" class="mx-1" style="width: 145px" placeholder="Início" />
              <span class="text-muted mx-1">até</span>
              <CecInputData ref="dt2" v-model="dt2" class="mx-1" style="width: 145px" placeholder="Fim" />
            </div>

            <div class="d-flex align-items-center px-2 border-left mr-1" style="min-width: 250px">
              <cliente-pesquisa 
                @retornaId="clienteId = $event"
                :idInicial="clienteId"
                label=""
                place="Fornecedor..."
                labelBotao=""
                ref="clientepesquisa"
                idModal="clientepesquisa"
                input-class="border-0 bg-transparent py-0"
              />
            </div>

            <b-button variant="primary" pill class="px-4 font-weight-bold shadow-sm" @click="pesquisar()">
              <i class="fa fa-search mr-1"></i> FILTRAR
            </b-button>
          </div>

          <b-button variant="success" pill class="px-4 ml-2 font-weight-bold shadow-sm text-white" @click="novo()">
            <i class="fa fa-plus-circle mr-1"></i> Nova Compra
          </b-button>
        </div>
      </div>

      <!-- Filtros Avançados Modernos -->
      <b-collapse v-model="filtro.avancado">
        <b-card class="card-filter-premium mb-4 border-0 shadow-sm">
          <div class="modal-section-title mb-3">Parâmetros Adicionais de Filtro</div>
          <b-row align-v="end">
            <b-col md="2">
              <label class="modal-label-premium">Nº Pedido</label>
              <b-form-input v-model="documento" placeholder="Ex: 12345" class="rounded-pill shadow-xs border-0 bg-light" />
            </b-col>
            <b-col md="2">
              <label class="modal-label-premium">Nº Controle (ID)</label>
              <b-form-input v-model="id" placeholder="Ex: 987" class="rounded-pill shadow-xs border-0 bg-light" />
            </b-col>
            <b-col md="2">
              <label class="modal-label-premium">Situação</label>
              <b-form-select v-model="tipoDoc" :options="optionsTipoDoc" class="rounded-pill shadow-xs border-0 bg-light" />
            </b-col>
            <b-col md="2">
              <label class="modal-label-premium">Tipo Período</label>
              <b-form-select v-model="tipoData" :options="optionsTipoData" class="rounded-pill shadow-xs border-0 bg-light" />
            </b-col>
            <b-col md="2">
              <div class="d-flex align-items-center mb-1">
                <label class="modal-label-premium mb-0 mr-2">Ignorar Período</label>
                <b-form-checkbox v-model="ignorarData" switch size="md" />
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-collapse>

      <!-- Tabela Financeira -->
       <b-row class="ml-0 mr-0 p-0" :class="isDark ? 'bg-dark' : 'bg-white'">
        <b-col sm="12" class="px-2">
          <div class="bg-white rounded border shadow-sm overflow-hidden">
            <b-table  ref="tbl" 
                    id="table-compras"        
                    class="table-finance mb-0"
                    primary-key="ID"
                    small
                    :dark="isDark"
                    responsive  hover  show-empty
                    empty-text="Nenhum registro encontrado para os filtros informados."
                    :busy.sync="isBusy" 
                    :sticky-header="stickyHeight"
                    :tbody-tr-class="rowClassSelecionado"
                    :items="itensFiltrados" 
                    :fields="fields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    @row-clicked="selecionarLinha"
                    @row-dblclicked="edit"
            >
              <!-- Custom Header Filters -->
              <template v-for="field in fields" v-slot:[`head(${field.key})`]="data">
                <div v-if="['ID', 'NUMERO_EXTERNO', 'OP_STATUS', 'FORNECEDOR_ID', 'NOME_FORNECEDOR', 'OP_TIPO_PEDIDO', 'NOTA_FISCAL', 'DT_PEDIDO', 'VL_PEDIDO'].includes(field.key)" :key="`filter-${field.key}`">
                    <SetFilter
                      :label="field.label"
                      v-model="filtros[field.key]"
                      :options="opcoes[field.key]"
                      :normalizeFn="normalize"
                      :dropdown-variant="isDark ? 'dark' : 'none'"
                    />
                </div>
                <span v-else :key="`label-${field.key}`">{{ field.label }}</span>
              </template>

              <!-- Ícone de expansão -->
              <template #cell(DETALHE)="row">
                <i 
                  :class="row.detailsShowing ? 'fa fa-angle-up' : 'fa fa-angle-down'"
                  @click.stop="toggleDetalhesCompra(row)"
                  style="cursor: pointer"
                ></i>
              </template>

              <!-- Detalhes Expansíveis -->
              <template #row-details="row">
                <div class="p-3 bg-light border-top border-bottom">
                  <div v-if="row.item.loading" class="text-center p-3">
                    <b-spinner small variant="primary" /> Carregando itens...
                  </div>
                  <div v-else>
                    <h6 class="modal-section-title mb-2">Itens da Compra</h6>
                    <b-table 
                        class="table-finance bg-white rounded shadow-xs mb-0"
                        hover
                        small
                        :items="row.item.detalhes" 
                        :fields="camposTabelaItens(row.item)"
                      />
                  </div>
                </div>
              </template>

              <template #cell(ID)="item">
                <span class="text-primary">{{ item.value }}</span>
              </template>

              <template #cell(NOME_FORNECEDOR)="item">
                <div class="d-flex flex-column">
                    <span class="font-weight-bold text-dark">{{ item.item.NOME_FORNECEDOR }}</span>
                    <span class="text-muted small">Cód: {{ item.item.FORNECEDOR_ID }}</span>
                </div>
              </template>  

              <template #cell(OP_STATUS)="item">
                <b-badge pill class="px-3 py-1 shadow-xs" :variant="colorirStatus(item.item.OP_STATUS)">
                  {{ traduzirSituacao(item.item.OP_STATUS) }}
                </b-badge>
              </template>      

              <template #cell(OP_TIPO_PEDIDO)="item">
                <div class="d-flex flex-wrap gap-1">
                  <b-badge pill class="shadow-xs mb-1" :variant="colorirOP_FINANCEIRO(item.item.OP_FINANCEIRO)">{{traduzirOP_FINANCEIRO(item.item.OP_FINANCEIRO)}}</b-badge>
                  <b-badge pill class="shadow-xs mb-1" :variant="colorirOP_TIPO_PEDIDO(item.item.OP_TIPO_PEDIDO)" >{{traduzOP_TIPO_PEDIDO(item.item.OP_TIPO_PEDIDO)}} </b-badge>
                  <b-badge pill class="shadow-xs mb-1" :variant="colorirOP_GERA_ESTOQUE(item.item.OP_GERA_ESTOQUE)">{{traduzirOP_GERA_ESTOQUE(item.item.OP_GERA_ESTOQUE)}}</b-badge>
                  <b-badge pill class="shadow-xs mb-1" :variant="colorirOP_XML(item.item.OP_XML)">{{traduzirOP_XML(item.item.OP_XML)}}</b-badge>
                </div>
              </template>      
              
              <template #cell(actions)="item">
                <div class="d-flex align-items-center gap-1">
                  <!-- Dropdown de Ações Extras -->
                  <b-dropdown
                      right
                      dropup 
                      boundary="viewport"
                      :popper-opts="{ positionFixed: true }"
                      no-caret
                      variant="link"
                      toggle-class="p-1 text-muted no-decoration"
                      class="mr-1"
                  > 
                    <template #button-content>
                      <b-button variant="soft-primary" pill class="btn-icon-only shadow-sm">
                        <i class="fa fa-ellipsis-v"></i>
                      </b-button>
                    </template>
                    <b-dropdown-item @click="edit(item.item)">
                      <i class="fa fa-edit mr-2 text-primary"></i> Editar Registro
                    </b-dropdown-item>
                    <b-dropdown-item v-if="(item.item.OP_STATUS || '').trim() !== '0'" @click.stop.prevent="imprimir(item.item.ID)">
                      <i class="fa fa-print mr-2 text-secondary"></i> Reimprimir
                    </b-dropdown-item>
                    <b-dropdown-item @click.stop.prevent="imprimirEspelho(item.item.ID)">
                      <i class="fa fa-file-text-o mr-2 text-info"></i> Espelho da Compra
                    </b-dropdown-item>
                    <b-dropdown-item v-if="(item.item.OP_STATUS || '').trim() !== '0'" @click.stop.prevent="imprimirPesagem(item.item.ID)">
                      <i class="fa fa-file-pdf-o mr-2 text-info"></i> Relatório de Pesagem
                    </b-dropdown-item>
                  </b-dropdown>

                  <!-- Botão PDF Nota -->
                  <b-button v-if="(item.item.OP_STATUS_NOTA_FISCAL_EMITIDA === 2)" variant="soft-primary" pill class="btn-icon-only shadow-sm" @click="downloadPDFNfe(item.item)" v-b-tooltip.hover title="Ver PDF">
                    <i class="fa fa-file-pdf-o"></i>
                  </b-button>

                  <!-- Botão Gerar Nota -->
                  <b-button v-else-if="(item.item.OP_STATUS || '').trim() === '1'" variant="soft-success" pill class="btn-icon-only shadow-sm" @click="abrirModalNotaFiscal(item.item)" v-b-tooltip.hover title="Gerar NF">
                    <i class="fa fa-file-pdf-o text-success"></i>
                  </b-button>

                  <!-- Botão Devolver -->
                  <b-button v-if="(item.item.OP_STATUS || '').trim() === '3'" variant="soft-info" pill class="btn-icon-only shadow-sm" @click="showMsgDevolver(item.item)" v-b-tooltip.hover title="Devolver">
                    <i class="fa fa-mail-reply-all"></i>
                  </b-button>
                  
                  <!-- Botão Cancelar: apenas para CADASTRANDO(1) ou CONCLUIDO(2) -->
                  <b-button v-if="(item.item.OP_STATUS || '').trim() === '1' || (item.item.OP_STATUS || '').trim() === '2'" variant="soft-danger" pill class="btn-icon-only shadow-sm" @click="abrirModalCancelamento(item.item)" v-b-tooltip.hover title="Cancelar">
                    <i class="fa fa-close"></i>
                  </b-button>
                </div>
              </template>

              <!-- Rodapé com Totais -->

              <template #custom-foot="{ fields, items }">
                <b-tr>
                  <b-td></b-td>
                  <b-td class="text-right font-weight-bold" v-for="(field, idx) in fields.slice(1)" :key="idx">
                    <!-- supondo que "campoValor" seja a key da coluna cujo total você quer -->
                    <span class="text-right font-weight-bold" v-if="field.key === 'ID'">Itens: ({{ itensFiltrados.length }})</span>
                    <span class="text-right font-weight-bold" v-if="field.key === 'VL_PEDIDO'">{{ vlPedidoRodape }}</span>
                  </b-td>
                </b-tr>
              </template>
            </b-table>
          </div>
        </b-col>
      </b-row>
    </div>
    <div>
      <!--  -----------------------------------------------------------------------------------
                                              MODAL CANCELAMENTO 
                ----------------------------------------------------------------------------------- -->
      <b-modal ref="modal-cancelamento" 
          id="modal-cancelamento" 
          hide-footer
          hide-header
          body-class="p-0 overflow-hidden"
          content-class="border-0 shadow-lg"
          size="lg"
          @shown="focusModalCancelamento()" 
      >
        <b-overlay :show="cancelamento.parametros.overlayBaixando" no-wrap fixed z-index="1100">
           <template #overlay>
              <div class="text-center p-4 bg-white rounded shadow-lg">
                <b-spinner variant="primary" type="grow" />
                <p class="mt-2 font-weight-bold">Processando...</p>
              </div>
           </template>
        </b-overlay>

        <div class="modal-header-premium bg-gradient-danger p-4 text-white">
            <div class="d-flex align-items-center">
                <div class="header-icon-wrapper bg-white-10 mr-3">
                    <i class="fa fa-times-circle text-white"></i>
                </div>
                <div>
                    <h5 class="mb-0 font-weight-bold">Cancelar Registro de Compra</h5>
                    <small class="text-white-50">Confirme os detalhes antes de efetivar a exclusão</small>
                </div>
            </div>
            <button type="button" class="close text-white" @click="$refs['modal-cancelamento'].hide()">×</button>
        </div>

        <div class="modal-info-bar bg-light p-3 border-bottom d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">
                <div class="mr-4">
                    <small class="modal-label-premium d-block">Fornecedor</small>
                    <span class="font-weight-bold text-dark">{{cancelamento.dados.nomeCliente}}</span>
                </div>
                <div>
                    <small class="modal-label-premium d-block">Pedido / Controle</small>
                    <span class="font-weight-bold text-primary">{{cancelamento.dados.documento}} / ID: {{cancelamento.dados.id}}</span>
                </div>
            </div>
            <div class="text-right">
                <small class="modal-label-premium d-block">Valor Total</small>
                <span class="font-weight-bold text-danger" style="font-size: 1.2rem">{{cancelamento.dados.valorDocumento}}</span>
            </div>
        </div>

        <div class="p-4">
            <div v-if="cancelamento.parametros.permissao === false" class="text-center py-4">
                 <div class="mb-3 text-danger"><i class="fa fa-exclamation-triangle fa-3x"></i></div>
                 <h5 class="text-danger font-weight-bold">Acesso Negado</h5>
                 <p class="text-muted">Você não possui permissão para cancelar registros de compra.</p>
            </div>

            <div v-else>
                <label class="modal-label-premium mb-2">Motivo do Cancelamento <span class="text-danger">*</span></label>
                <b-form-textarea 
                    ref="motivoCancelamento" 
                    v-model="cancelamento.dados.motivo" 
                    :state="valMotivoCancelamento"
                    placeholder="Descreva detalhadamente o motivo do cancelamento deste registro..." 
                    rows="4"
                    class="rounded shadow-xs border-0 bg-light p-3"
                />
            </div>
        </div>

        <div class="modal-footer-premium p-3 bg-light d-flex justify-content-end gap-2 border-top">
            <b-button variant="soft-danger" pill class="px-4" @click="$refs['modal-cancelamento'].hide()">
                DESCARTAR
            </b-button>
            <b-button v-if="cancelamento.parametros.permissao === true" variant="danger" pill class="px-4 shadow-sm" @click="cancelar()">
                <i class="fa fa-check mr-2"></i> CONFIRMAR CANCELAMENTO
            </b-button>
        </div>
      </b-modal>
    </div>
    <div>
      <!--  -----------------------------------------------------------------------------------
                                            MODAL INFO 
      ----------------------------------------------------------------------------------- -->
      <b-modal ref="modal-info" 
          id="modal-info" 
          hide-footer
          hide-header
          body-class="p-0 overflow-hidden"
          content-class="border-0 shadow-lg"
          size="xl"
      >
        <div class="modal-header-premium bg-gradient-dark p-4 text-white">
            <div class="d-flex align-items-center">
                <div class="header-icon-wrapper bg-white-10 mr-3">
                    <i class="fa fa-info-circle text-white"></i>
                </div>
                <div>
                    <h5 class="mb-0 font-weight-bold">Detalhamento do Registro</h5>
                    <small class="text-white-50">Consulta completa de itens e históricos da compra</small>
                </div>
            </div>
            <button type="button" class="close text-white" @click="$refs['modal-info'].hide()">×</button>
        </div>

        <div class="modal-info-bar bg-light p-3 border-bottom d-flex justify-content-between">
            <div class="d-flex gap-4">
                <div class="border-right pr-4">
                    <small class="modal-label-premium d-block">Fornecedor</small>
                    <span class="font-weight-bold text-dark">{{dadosModalInfo.nomeCliente}}</span>
                </div>
                <div class="border-right pr-4">
                    <small class="modal-label-premium d-block">Comprador</small>
                    <span class="font-weight-bold text-dark">{{dadosModalInfo.nomeVendedor}}</span>
                </div>
                <div class="border-right pr-4">
                    <small class="modal-label-premium d-block">Documento</small>
                    <span class="font-weight-bold text-primary">{{dadosModalInfo.documento}}</span>
                </div>
                <div>
                    <small class="modal-label-premium d-block">Data Emissão</small>
                    <span class="font-weight-bold text-dark">{{dadosModalInfo.dataVenda}}</span>
                </div>
            </div>
            <div class="text-right">
                <small class="modal-label-premium d-block text-right">Total da Compra</small>
                <span class="font-weight-bold text-success" style="font-size: 1.3rem">{{dadosModalInfo.total}}</span>
            </div>
        </div>

        <div class="p-4 bg-white" style="max-height: 60vh; overflow-y: auto;">
            <b-row class="mb-4">
                <b-col md="6">
                    <div class="modal-section-title mb-2">Histórico de Alteração</div>
                    <div class="p-3 bg-light rounded border shadow-xs h-100">
                        <div class="d-flex mb-2">
                           <div class="w-50">
                               <small class="modal-label-premium d-block">Usuário</small>
                               <span class="text-dark">{{dadosModalInfo.usuarioAlteracao || '—'}}</span>
                           </div>
                           <div class="w-50">
                               <small class="modal-label-premium d-block">Data/Hora</small>
                               <span class="text-dark">{{dadosModalInfo.dataAlteracao || '—'}}</span>
                           </div>
                        </div>
                        <small class="modal-label-premium d-block">Motivo da Alteração</small>
                        <p class="mb-0 text-muted italic small">{{dadosModalInfo.motivoAlteracao || 'Nenhuma alteração registrada.'}}</p>
                    </div>
                </b-col>
                <b-col md="6">
                    <div class="modal-section-title mb-2 text-danger text-opacity-75">Registro de Cancelamento</div>
                    <div class="p-3 bg-soft-danger rounded border shadow-xs h-100">
                        <div class="d-flex mb-2">
                           <div class="w-50">
                               <small class="modal-label-premium d-block">Cancelado por</small>
                               <span class="text-dark">{{dadosModalInfo.usuarioCancelamento || '—'}}</span>
                           </div>
                           <div class="w-50">
                               <small class="modal-label-premium d-block">Data/Hora</small>
                               <span class="text-dark">{{dadosModalInfo.dataCancelamento || '—'}}</span>
                           </div>
                        </div>
                        <small class="modal-label-premium d-block">Justificativa</small>
                        <p class="mb-0 text-muted italic small">{{dadosModalInfo.motivoCancelamento || 'Registro ativo (não cancelado).'}}</p>
                    </div>
                </b-col>
            </b-row>

            <div class="modal-section-title mb-3">Itens do Pedido</div>
            <b-table 
                class="table-finance border rounded"
                hover 
                show-empty
                empty-text="Nenhum item lançado nesta compra."
                small
                responsive 
                head-variant="light"
                :items="tabelaItens.items" 
                :fields="camposTabelaItens(compraContextoTabelaItens)"
            />
        </div>

        <div class="modal-footer-premium p-3 bg-light d-flex justify-content-end border-top">
            <b-button variant="soft-danger" pill class="px-5 shadow-sm" @click="$refs['modal-info'].hide()">
                FECHAR DETALHES
            </b-button>
        </div>
      </b-modal>
    </div>
     <!--  -----------------------------------------------------------------------------------
                                            MODAL NOTA FISCAL
      ----------------------------------------------------------------------------------- -->
    <div>
      <b-modal ref="modal-nota-fiscal" 
          id="modal-nota-fiscal" 
          hide-footer
          hide-header
          body-class="p-0 overflow-hidden"
          content-class="border-0 shadow-lg"
          size="xl"
      >
        <div class="modal-header-premium bg-gradient-info p-4 text-white">
            <div class="d-flex align-items-center">
                <div class="header-icon-wrapper bg-white-10 mr-3">
                    <i class="fa fa-file-text-o text-white"></i>
                </div>
                <div>
                    <h5 class="mb-0 font-weight-bold">Emissão de Nota Fiscal Eletrônica</h5>
                    <small class="text-white-50">Configure os parâmetros fiscais para transmissão da NF-e</small>
                </div>
            </div>
            <button type="button" class="close text-white" @click="$refs['modal-nota-fiscal'].hide()">×</button>
        </div>

        <div class="modal-info-bar bg-light p-3 border-bottom d-flex justify-content-between">
            <div class="d-flex gap-4">
                <div class="border-right pr-4">
                    <small class="modal-label-premium d-block">Destinatário</small>
                    <span class="font-weight-bold text-dark">{{dadosModalNotaFiscal.nomeCliente}}</span>
                </div>
                <div class="border-right pr-4">
                    <small class="modal-label-premium d-block">Documento Base</small>
                    <span class="font-weight-bold text-primary">{{dadosModalNotaFiscal.documento}}</span>
                </div>
            </div>
            <div class="text-right">
                <small class="modal-label-premium d-block text-right">Valor da Nota</small>
                <span class="font-weight-bold text-info" style="font-size: 1.3rem">{{dadosModalNotaFiscal.total}}</span>
            </div>
        </div>

        <div class="p-4 bg-white" style="max-height: 60vh; overflow-y: auto;">
            <div class="modal-section-title mb-3">Parâmetros Fiscais de Emissão</div>
            <b-row class="mb-3">
                <b-col md="6">
                   <label class="modal-label-premium mb-1 ml-2">Empresa Emitente</label>
                   <b-form-select 
                        v-model="dadosModalNotaFiscal.empresaId"
                        :options="dadosModalNotaFiscal.empresas.options" 
                        :state="valEmpresaId"
                        class="rounded-pill shadow-xs border-0 bg-light"
                    />
                </b-col>
                <b-col md="6">
                   <label class="modal-label-premium mb-1 ml-2">Natureza da Operação</label>
                   <b-form-select 
                        v-model="dadosModalNotaFiscal.tipoMovimentacaoId"
                        :options="dadosModalNotaFiscal.tipoMovimentacoes.options" 
                        :state="valTipoMovimentacaoId"
                        class="rounded-pill shadow-xs border-0 bg-light"
                    />
                </b-col>
            </b-row>

            <b-row class="mb-3">
               <b-col md="6">
                   <label class="modal-label-premium mb-1 ml-2">CFOP</label>
                   <b-form-select 
                        v-model="dadosModalNotaFiscal.cfopId"
                        :options="dadosModalNotaFiscal.cfops.options" 
                        :state="valCfopId"
                        class="rounded-pill shadow-xs border-0 bg-light"
                    />
                </b-col>
                <b-col md="3">
                   <label class="modal-label-premium mb-1 ml-2">Consumidor Final</label>
                   <b-form-select 
                        v-model="dadosModalNotaFiscal.consumidor"
                        :options="optionsConsumidor" 
                        :state="valConsumidor"
                        class="rounded-pill shadow-xs border-0 bg-light"
                    />
                </b-col>
                <b-col md="3">
                   <label class="modal-label-premium mb-1 ml-2">Texto Predefinido</label>
                   <b-form-select 
                        v-model="dadosModalNotaFiscal.textoId"
                        :options="dadosModalNotaFiscal.textos.options" 
                        class="rounded-pill shadow-xs border-0 bg-light"
                    />
                </b-col>
            </b-row>

            <b-row class="mb-4">
                <b-col md="6">
                    <label class="modal-label-premium mb-1 ml-2">Observações ao Contribuinte</label>
                    <b-form-textarea 
                        v-model="dadosModalNotaFiscal.obsContribuinte" 
                        placeholder="Mensagens de interesse do contribuinte..." 
                        rows="3"
                        class="rounded shadow-xs border-0 bg-light"
                    />
                </b-col>
                <b-col md="6">
                    <label class="modal-label-premium mb-1 ml-2">Outras Observações</label>
                    <b-form-textarea 
                        v-model="dadosModalNotaFiscal.obsOutros" 
                        placeholder="Observações do Fisco (ex: Boleto, Local de Entrega)..." 
                        rows="3"
                        class="rounded shadow-xs border-0 bg-light"
                    />
                </b-col>
            </b-row>

            <div class="modal-section-title mb-3">Conferência de Itens</div>
            <b-table 
                class="table-finance border rounded"
                hover 
                show-empty
                small
                responsive 
                head-variant="light"
                :items="tabelaItens.items" 
                :fields="camposTabelaItens(compraContextoTabelaItens)"
            />
        </div>

        <div class="modal-footer-premium p-3 bg-light d-flex justify-content-end gap-2 border-top">
            <b-button variant="soft-danger" pill class="px-4 shadow-sm" @click="$refs['modal-nota-fiscal'].hide()">
                CANCELAR
            </b-button>
            <b-button variant="primary" pill class="px-4 shadow-sm" @click="emitirNotaFiscal()">
                <i class="fa fa-paper-plane mr-2"></i> TRANSMITIR NF-E AGORA
            </b-button>
        </div>
      </b-modal>
    </div>

    <ModalAlertaResultadoGrande
      ref="modalConfirmarResultadoGrande"
      :count="resultadoPendenteCount"
      @confirmar="confirmarCarregarResultadoGrande"
      @cancelar="cancelarCarregarResultadoGrande"
      @shown="modalConfirmacaoAberto = true"
      @hidden="modalConfirmacaoAberto = false"
    />
  </div>
</template>

<script>
// https://github.com/simonbengtsson/jsPDF-AutoTable/blob/master/examples/webpack/main.js
import VueButtonSpinner from '../../../components/VueButtonSpinner.vue'
import ClientePesquisa from '../../pesquisa/ClientePesquisa.vue'
import ModalAlertaResultadoGrande from '@/views/modal/ModalAlertaResultadoGrande.vue'
import moment from 'moment'
import Tools from '@/tools/tools.js'
import SetFilter from '@/components/Cec/SetFilter.vue'
import CecInputData from '@/components/Cec/CecInputData.vue'
import { createCecTableToolsMixin } from '@/mixins/cecTableTools'
import { printHtmlReport, exportExcelXlsx , exportCsv } from '@/utils/RelatorioHTML';
import { imprimirEspelhoCompra } from '@/utils/RelatorioCompraHTML.js'

export default {
  components: {
    VueButtonSpinner,
    ClientePesquisa,
    ModalAlertaResultadoGrande,
    SetFilter,
    CecInputData
  },

  mixins: [createCecTableToolsMixin({
    rowsProp: 'lista',
    tblRef: 'tbl',
    preferVh: 65,
    useExternalPaging: true,
    filters: [
      { key: 'ID', type: 'number', label: 'ID' },
      { key: 'NUMERO_EXTERNO', type: 'string', label: 'Externo' },
      { key: 'OP_STATUS', type: 'string', label: 'Situação' },
      { key: 'FORNECEDOR_ID', type: 'number', label: 'For.ID' },
      { key: 'NOME_FORNECEDOR', type: 'string', label: 'Fornecedor' },
      { key: 'OP_STATUS', type: 'string', label: 'Situação' },
      { key: 'OP_TIPO_PEDIDO', type: 'string', label: 'Tipo Pedido' },
      { key: 'NOTA_FISCAL', type: 'string', label: 'Nota Fiscal' },
      { key: 'DT_PEDIDO', type: 'date', label: 'Data do Pedido' },
      { key: 'VL_PEDIDO', type: 'number', label: 'Valor do Pedido' },

    ]
  })],

  data () {
    return {
      filtro: {
        avancado: false
      },
      cancelamento: {
        parametros: {
          overlayBaixando: false,
          permissao: false,
          processando: false,
          busy: false
        },
        dados: {
          titulo: null,
          id: null,
          nomeCliente: '',
          documento: '',
          parcela: '',
          motivo: '',
          dataVencimento: 0.00,
          gta: '',
          valorDocumento: 0.00,
          usuario: ''
        }
      },
      dadosModalNotaFiscal: {
        venda: null,
        id: null,
        documento: null,
        dataVenda : null,
        nomeCliente: null,
        nomeVendedor: null,
        empresaId: null,
        cliente: null,
        tipoMovimentacaoId: null,
        cfopId: null,
        consumidor: null,
        textoId: null,
        obsContribuinte: null,
        obsOutros: null,
        total: 0.00,
        tipoMovimentacoes : {
          selected: null,
          options: null,
          items: []
        },
        cfops : {
          selected: null,
          options: null,
          items: []
        },
        empresas : {
          selected: null,
          options: null,
          items: []
        },
        textos : {
          selected: null,
          options: null,
          items: []
        },
        

      },
      dadosModalInfo: {
        id: null,
        documento: null,
        dataVenda : null,
        nomeCliente: null,
        nomeVendedor: null,
        usuarioAlteracao: null,
        dataAlteracao: null,
        motivoAlteracao: null,
        usuarioCancelamento: null,
        dataCancelamento: null,
        motivoCancelamento: null,
        total: 0.00

      },
      tabelaItens: {
        fields: [],
        items: [],
        compra: null
      },
      optionsTipoDoc: [
        { value: '', text: 'Todos' },
        { value: '0', text: 'Cancelado' },
        { value: '1', text: 'Fechado' },
        { value: '2', text: 'Aberto' }
      ],
      optionsTipoData: [
        { value: '0', text: 'Efetivação/Pedido' },
        { value: '1', text: 'Carregamento Origem' },
        { value: '2', text: 'Descarregamento' }
      ],
      
      optionsConsumidor: [
        { value: '', text: '' },
        { value: '0', text: 'Não' },
        { value: '1', text: 'Sim' },
      ],
      status: '',
      isBusy: false,
      resultadoPendente: null,
      resultadoPendenteCount: 0,
      modalConfirmacaoAberto: false,
      fields: [
        { key: "DETALHE", label: '',  class:'align-middle text-center p-0', thStyle: { width: "2%" }},
        { key: "ID", label: 'ID',  sortable: true, class:'align-middle text-center p-0', thStyle: { width: "5%" } },
        { key: "NUMERO_EXTERNO", label: 'Externo', sortable: true, class:'align-middle text-center p-0', thStyle: { width: "5%" }  },
        { key: "OP_STATUS", label: 'Situação',  sortable: true, thStyle: { width: "5%" }  },
        /*{ key: "FORNECEDOR_ID", label: 'F.ID', sortable: true, thStyle: { width: "5%" } },*/
        { key: "NOME_FORNECEDOR", label: 'Fornecedor', sortable: true, thStyle: { width: "20%" }  },
        { key: "NOTA_FISCAL", label: 'Nota Fiscal', sortable: true, thStyle: { width: "20%" }  },
        { key: "DT_PEDIDO", label: 'Data',  sortable: true, thStyle: { width: "10%" },
          formatter: (value, key, item) => value ? moment(String(value)).format('DD/MM/YYYY') : null} ,
        { key: "OP_TIPO_PEDIDO", label: 'Informações',  sortable: true , thStyle: { width: "13%" } },
        { key: 'VL_PEDIDO', class:'text-right', label: 'Total (R$)', sortable: true, thStyle: { width: "10%" }, 
          formatter: (value, key, item) =>  this.formatCurrency(value) , thStyle: { width: "5%" }},
        { key: "actions" , label: 'Ações', class:'text-right p-0 align-middle', thStyle: { width: "5%" } }
      ],
      modalDetails: { index: '', data: '' },
      columns: [
        {title: 'ID', dataKey: 'id'},
        {title: 'Name', dataKey: 'name'},
        {title: 'Country', dataKey: 'country'}
      ],
      rows: [
        {'id': 1, 'name': 'Shaw', 'country': 'Tanzania'},
        {'id': 2, 'name': 'Nelson', 'country': 'Kazakhstan'},
        {'id': 3, 'name': 'Garcia', 'country': 'Madagascar'}
      ]
    }
  },
  
  computed: {
    isDark() {return this.$store.getters['tema/IS_DARK']  },
    compraContextoTabelaItens() {
      return this.tabelaItens.compra || {}
    },
    vlPedidoRodape() {
      let auxValor = (this.itensFiltrados || []).reduce((s, i) => s + (Number(i.VL_PEDIDO) || 0), 0)
      return this.formatCurrency(auxValor)
    },
    valMotivoCancelamento() {
      return ((this.cancelamento.dados.motivo ) && (this.cancelamento.dados.motivo != '')) ? true : false 
    },
    valEmitirNotaFiscal() {
      return this.valEmpresaId && this.valTipoMovimentacaoId && this.valCfopId && this.valConsumidor
    },
    valEmpresaId() {
      return this.dadosModalNotaFiscal.empresaId ? true : false
    },
    valTipoMovimentacaoId() {
      return this.dadosModalNotaFiscal.tipoMovimentacaoId ? true : false
    },
    valCfopId() {
      return this.dadosModalNotaFiscal.cfopId ? true : false
    },
    valConsumidor() {
      return this.dadosModalNotaFiscal.consumidor ? true : false
    },
    
    user () {
      return '' // this.$store.state.dadosSessao.nome
    },
    currentPage: {
      get () {
        return this.$store.getters['compra/PAGINA_ATUAL']
      }, 
      set (value) {
        this.$store.commit("compra/SET_PAGINA_ATUAL", value);
      }
    },
    perPage: {
      get () {
        return this.$store.getters['compra/PER_PAGE'] || 25
      },
      set (v) {
        this.$store.commit('compra/SET_PER_PAGE', Number(v) || 25)
      }
    },
    dt1: {
      get () {
        return this.$store.getters['compra/DT1']
      }, 
      set (value) {
        this.$store.commit("compra/SET_DT1", value);
      }
    },
    dt2: {
      get () {
        return this.$store.getters['compra/DT2']
      }, 
      set (value) {
        this.$store.commit("compra/SET_DT2", value);
      }
    },
    id: {
      get () {
        return this.$store.getters['compra/ID']
      }, 
      set (value) {
        this.$store.commit("compra/SET_ID", value);
      }
    },
    documento: {
      get () {
        return this.$store.getters['compra/DOCUMENTO']
      }, 
      set (value) {
        this.$store.commit("compra/SET_DOCUMENTO", value);
      }
    },
    clienteId: {
      get () {
        return this.$store.getters['compra/CLIENTE_ID']
      }, 
      set (value) {
        this.$store.commit("compra/SET_CLIENTE_ID", value)
      }
    },
    transportadoraId: {
      get () {
        return this.$store.getters['compra/TRANSPORTADORA_ID']
      }, 
      set (value) {
        this.$store.commit("compra/SET_TRANSPORTADORA_ID", value)
      }
    },
    tipoDoc: {
      get () {
        return this.$store.getters['compra/TIPO_DOC']
      }, 
      set (value) {
        this.$store.commit("compra/SET_TIPO_DOC", value)
      }
    },
    tipoData: {
      get () {
        return this.$store.getters['compra/TIPO_DATA']
      }, 
      set (value) {
        this.$store.commit("compra/SET_TIPO_DATA", value)
      }
    },
    ignorarData: {
      get () {
        return this.$store.getters['compra/IGNORAR_DATA']
      }, 
      set (value) {
        this.$store.commit("compra/SET_IGNORAR_DATA", value)
      }
    },
    lista: {
      get () {
        return this.$store.getters['compra/LISTA']
      }, 
      set (value) {
        this.$store.commit("compra/SET_LISTA", value)
      }
    }
  },
  methods: {
    compraEhAlmoxarifado(compra) {
      return String(compra?.OP_TIPO_PEDIDO || '').trim() === 'A'
    },
    camposTabelaItens(compra = null) {
      const campos = [
        { key: 'PRODUTO_ID', label: 'ID' },
        { key: 'NOME_PRODUTO', label: this.compraEhAlmoxarifado(compra) ? 'Material' : 'Produto' },
        {
          key: 'QT_PECAS',
          class: 'text-right',
          label: 'Volumes',
          formatter: value => this.formatDecimal(value, 2)
        },
        {
          key: 'NR_PESO_LIQUIDO',
          class: 'text-right',
          label: 'Quantidade',
          formatter: value => this.formatDecimal(value, 3)
        },
        {
          key: 'ID_UNIDADE_COMERCIAL',
          class: 'text-center',
          label: 'Unid.'
        },
        {
          key: 'NR_PESO_BRUTO',
          class: 'text-right',
          label: 'Peso Bruto',
          formatter: value => this.formatDecimal(value, 3)
        }
      ]

      if (this.compraEhAlmoxarifado(compra)) {
        campos.push({
          key: 'QUANT_NFE',
          label: 'Quant NFE Almox',
          class: 'text-right',
          formatter: value => this.formatDecimal(value, 2)
        })
      }

      campos.push(
        {
          key: 'VL_UNITARIO_FOB',
          label: 'FOB R$',
          class: 'text-right',
          formatter: value => this.formatCurrency(value)
        },
        {
          key: 'VL_TOTAL_FOB',
          label: 'Total FOB R$',
          class: 'text-right',
          formatter: value => this.formatCurrency(value)
        },
        {
          key: 'VL_ICMS',
          label: 'ICMS',
          class: 'text-right',
          formatter: value => this.formatCurrency(value)
        },
        {
          key: 'VL_PIS',
          label: 'PIS',
          class: 'text-right',
          formatter: value => this.formatCurrency(value)
        },
        {
          key: 'VL_COFINS',
          label: 'COFINS',
          class: 'text-right',
          formatter: value => this.formatCurrency(value)
        },
        {
          key: 'VL_IBS',
          label: 'IBS',
          class: 'text-right',
          formatter: value => this.formatCurrency(value)
        },
        {
          key: 'VL_CBS',
          label: 'CBS',
          class: 'text-right',
          formatter: value => this.formatCurrency(value)
        },
        {
          key: 'VL_IS',
          label: 'IIS',
          class: 'text-right',
          formatter: value => this.formatCurrency(value)
        }
      )

      return campos
    },
    normalizarItemCompra(item) {
      const pesoLiquido = Number(item?.NR_PESO_LIQUIDO ?? item?.NR_PESO_BRUTO ?? 0)
      return {
        ...item,
        ID_UNIDADE_COMERCIAL: String(item?.ID_UNIDADE_COMERCIAL || item?.UNIDADE || 'UND').trim() || 'UND',
        NR_PESO_LIQUIDO: pesoLiquido,
        NR_PESO_BRUTO: Number(item?.NR_PESO_BRUTO ?? 0),
        QT_PECAS: Number(item?.QT_PECAS ?? item?.PECAS ?? 0),
        QUANT_NFE: Number(item?.QUANT_NFE ?? 0),
        VL_UNITARIO_FOB: Number(item?.VL_UNITARIO_FOB ?? 0),
        VL_TOTAL_FOB: Number(item?.VL_TOTAL_FOB ?? 0),
        VL_ICMS: Number(item?.VL_ICMS ?? 0),
        VL_PIS: Number(item?.VL_PIS ?? 0),
        VL_COFINS: Number(item?.VL_COFINS ?? 0),
        VL_IBS: Number(item?.VL_IBS ?? 0),
        VL_CBS: Number(item?.VL_CBS ?? 0),
        VL_IS: Number(item?.VL_IS ?? 0)
      }
    },
    async toggleDetalhesCompra(row) {
      if (row.detailsShowing) {
        row.toggleDetails()
        return
      }

      if (!row.item.detalhes && !row.item.loading) {
        this.$set(row.item, 'loading', true)

        const detalhes = await this.getItens(row.item.ID)

        this.$set(row.item, 'detalhes', (detalhes || []).map(item => this.normalizarItemCompra(item)))
        this.$set(row.item, 'loading', false)
      }

      row.toggleDetails()
    },

    async onToggleDetails(row, expanded) {
      // Apenas necessário se quiser reagir diretamente ao evento
    },
    exportarHtml () {
      printHtmlReport({
        rows: this.itensFiltrados,
        columns: this.fields,
        systemName: 'CECWeb',
        reportTitle: 'Listagem de Compras',
        printedBy: window.localStorage.getItem('login') ?? '—',
        observations: `Período: ${this.dt1} a ${this.dt2}`,
        pageSize: 'A4',
        landscape: true,
      });
    },
    exportarExcel(){
      exportExcelXlsx ({
        rows: this.itensFiltrados,
        columns: this.fields,
        filename: 'compras.xls'
      });
    },
    exportarCsv(){
      exportCsv({
        rows: this.itensFiltrados,
        columns: this.fields,
        filename: 'compras.csv',
      });
    },

    async buscarDetalhesCompra(id) {
      // Simula chamada backend

      const itensResult = await this.$http.get(`/api/protected/gestaoCompra/notaFiscal/listarItensDaNota/${id}`)
      return itensResult.data ?? null

    },
    async getItens(compraId) {
      try {
        const response = await this.$http.get('/api/protected/gestaoCompra/item/getByCompraId/'+compraId)
        return (response.data ?? []).map(item => this.normalizarItemCompra(item))
      } catch (err) {
        console.error('Erro em getItens:', err)
        throw new Error(err)
      }
    },
    async downloadPDFNfe (item) {
      try {
        this.$store.commit('controle/setAguardando', true)

        const body = {
          nfeId: item.NOTA_FISCAL_ID,
          empresaId: item.EMPRESA_NOTA_FISCAL_ID
        }

        const response = await this.$http.post(`/api/protected/notaFiscal/downloadPDF/`, body)

        const resultado = response.data

        if (!resultado || !resultado.sucesso || !resultado.pdfBase64) {
          const erro = resultado?.erro || 'Não foi possível baixar o PDF da Nota Fiscal.'
          Tools.exibirMensagem(this.$store, 'Erro', 'danger', erro)
          return
        }

        // Converte base64 para blob
        const byteCharacters = atob(resultado.pdfBase64)
        const byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        const blob = new Blob([byteArray], { type: 'application/pdf' })

        // Cria a URL e abre o PDF
        const url = window.URL.createObjectURL(blob)
        window.open(url)

        
        

      } catch (err) {
        console.error('Erro na download da nota:', err)

        const erroMsg = err.response?.data?.erro || 'Falha inesperada ao gerar a nota fiscal.'
        this.$root.$bvToast.toast(erroMsg, {
          title: 'Erro',
          autoHideDelay: 2000,
          variant: 'danger',
          appendToast: true
        })

      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async emitirNotaFiscal () {
      if (!this.valEmitirNotaFiscal) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Preencha os campos obrigatórios')
        return
      }

      try {
        this.$store.commit('controle/setAguardando', true)

        const body = {
          vendaId: this.dadosModalNotaFiscal.id,
          cfopId: this.dadosModalNotaFiscal.cfopId,
          empresaId: this.dadosModalNotaFiscal.empresaId,
          natureza: 'teste',
          textoContribuinte: this.dadosModalNotaFiscal.obsContribuinte,
          textoOutros: this.dadosModalNotaFiscal.obsOutros,
          consumidor: this.dadosModalNotaFiscal.consumidor,
          usuario: window.localStorage.getItem('login')
        }

        const response = await this.$http.post(`/api/protected/notaFiscal/gerarIntegrador/`, body)

        const resultado = response.data

        if (!resultado || !resultado.sucesso || !resultado.pdfBase64) {
          const erro = resultado?.erro || 'Não foi possível gerar o PDF.'
          Tools.exibirMensagem(this.$store, 'Erro', 'danger', erro)
          return
        }

        // Converte base64 para blob
        const byteCharacters = atob(resultado.pdfBase64)
        const byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        const blob = new Blob([byteArray], { type: 'application/pdf' })

        // Cria a URL e abre o PDF
        const url = window.URL.createObjectURL(blob)
        window.open(url)

        await this.pesquisar()

        this.$refs['modal-nota-fiscal'].hide()

        this.$root.$bvToast.toast(`Nota Fiscal gerada com sucesso!`, {
          title: 'Aviso',
          autoHideDelay: 2000,
          variant: 'success',
          appendToast: true
        })

      } catch (err) {
        console.error('Erro na geração da nota:', err)

        Tools.exibirMensagem(this.$store, 'Erro', 'danger', err)

      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async abrirModalNotaFiscal(item) {
      try {
        this.$store.commit('controle/setAguardando', true)
        this.$store.commit("compra/SET_REGISTRO_SELECIONADO_ID", item.ID)
        try {
          await this.carregarTipoMovimentacoes()
        } catch(err) {
          console.log(err)
        }

        try {
          await this.carregarCFOP()
        } catch(err) {
          console.log(err)
        }
        try {
          await this.carregarEmpresas()
        } catch(err) {
          console.log(err)
        }
        try {
          await this.carregarTextos()
        } catch(err) {
          console.log(err)
        }

        try {
          await this.carregarCliente(item.COD_CLI)
        } catch(err) {
          console.log(err)
        }

        this.dadosModalNotaFiscal.obsOutros = null
        try {
          const boletoResult = await this.$http.get('/api/protected/areceber/getInfoBoletoByVendaId/'+item.ID)
          const boleto = boletoResult.data?.[0]
          if (boleto) {
            this.dadosModalNotaFiscal.obsOutros = ' BOLETO: ' + boleto.TITULO_NOSSONUMERO
          }
        } catch(err) {
          console.log(err)
        }

        const tipoMovimentacao = this.dadosModalNotaFiscal.tipoMovimentacoes.items.find(tipos =>
          tipos.ID === item.TIPO_MOVIMENTACAO_ID
        )
        this.dadosModalNotaFiscal.tipoMovimentacaoId = tipoMovimentacao.ID?? null
        this.dadosModalNotaFiscal.cfopId = tipoMovimentacao.CFOP_ID?? null
        this.dadosModalNotaFiscal.consumidor = this.dadosModalNotaFiscal.cliente.OP_CONSUMIDOR

        this.tabelaItens.items = null
        this.tabelaItens.compra = item
        this.dadosModalNotaFiscal.id = null
        this.dadosModalNotaFiscal.documento = null
        this.dadosModalNotaFiscal.dataVenda = null
        this.dadosModalNotaFiscal.nomeCliente = null
        this.dadosModalNotaFiscal.nomeVendedor = null
        this.dadosModalNotaFiscal.total = null
        try {
      
          const response = await this.$http.get('/api/protected/compra/item/getListagemBycompra/'+item.ID)
          this.tabelaItens.items = (response.data ?? []).map(itemCompra => this.normalizarItemCompra(itemCompra))
      
          this.dadosModalNotaFiscal.id = item.ID
          this.dadosModalNotaFiscal.documento = item.N_VENDA
          this.dadosModalNotaFiscal.dataVenda = item.DT_SAIDA ? moment(String(item.DT_SAIDA)).format('DD/MM/YYYY') : ''
          this.dadosModalNotaFiscal.nomeCliente = item.NOME_CLIENTE
          this.dadosModalNotaFiscal.nomeVendedor = item.NOME_VENDEDOR
          this.dadosModalNotaFiscal.total = this.formatCurrency(item.VL_TOTAL_NFE)

          this.$store.commit("compra/SET_REGISTRO_SELECIONADO_ID", ITEM.ID)
          this.$refs['modal-nota-fiscal'].show()
        } catch(err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Operação indisponível' )
        }
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async carregarTipoMovimentacoes() {
      try {
        const response = await this.$http.get(`/api/protected/tipoMovimentacao/listar`)
        const dados = response.data

        //Armazenar também os itens
        this.dadosModalNotaFiscal.tipoMovimentacoes.items = response.data

        //preencher o combo
        this.dadosModalNotaFiscal.tipoMovimentacoes.options = []
        if (Array.isArray(dados)) {
          for (const tipo of dados) {
            this.dadosModalNotaFiscal.tipoMovimentacoes.options.push({
              value: tipo.ID,
              text: tipo.ID + ' - ' + tipo.DESCRICAO
            })
          }
        }

        return dados

      } catch (err) {
        console.error('Erro em carregarTipoMovimentacoes:', err)
        return null
      }
    },
    async carregarCFOP() {
      try {
        const response = await this.$http.get(`/api/protected/cfop/listarTodos`)
        const dados = response.data

        //Armazenar também os itens
        this.dadosModalNotaFiscal.cfops.items = response.data

        //preencher o combo
        this.dadosModalNotaFiscal.cfops.options = []
        if (Array.isArray(dados)) {
          for (const tipo of dados) {
            this.dadosModalNotaFiscal.cfops.options.push({
              value: tipo.CONTADOR,
              text: tipo.CONTADOR + ' - ' + tipo.UTILIZACAO
            })
          }
        }

        return dados

      } catch (err) {
        console.error('Erro em carregarCFOP:', err)
        return null
      }
    },
    async carregarEmpresas() {
      try {
        const response = await this.$http.get(`/api/protected/empresa/getTodas`)
        const dados = response.data

        //Armazenar também os itens
        this.dadosModalNotaFiscal.empresas.items = response.data

        //preencher o combo
        this.dadosModalNotaFiscal.empresas.options = []
        if (Array.isArray(dados)) {
          for (const tipo of dados) {
            this.dadosModalNotaFiscal.empresas.options.push({
              value: tipo.CODIGO,
              text: tipo.IE + ' - ' + tipo.RAZAO 
            })
          }
        }

        return dados

      } catch (err) {
        console.error('Erro em carregarEmpresas:', err)
        return null
      }
    },
    async carregarTextos() {
      try {
        const response = await this.$http.get(`/api/protected/parametro/getTextos`)
        const dados = response.data

        //Armazenar também os itens
        this.dadosModalNotaFiscal.textos.items = response.data

        //preencher o combo
        this.dadosModalNotaFiscal.textos.options = []
        if (Array.isArray(dados)) {
          for (const tipo of dados) {
            this.dadosModalNotaFiscal.textos.options.push({
              value: tipo.ID??'',
              text: tipo.ID ? tipo.ID + ' - ' + tipo.DESCRICAO : ''
            })
          }
        }

        return dados

      } catch (err) {
        console.error('Erro em carregarTextos:', err)
        return null
      }
    },
    async carregarCliente(clienteId) {
      try {
        const response = await this.$http.get(`/api/protected/cliente/getById/${clienteId}`)
        this.dadosModalNotaFiscal.cliente = response.data?.[0]
        return true
      } catch (err) {
        console.error('Erro em carregarTextos:', err)
        return false
      }
    },
    async cancelar() {
      if (!this.valMotivoCancelamento) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o Motivo' )
        return
      }
      try {
        this.$store.commit('controle/setAguardando', true)

        const body = {
          compraId: this.cancelamento.dados.id,
          motivo:   this.cancelamento.dados.motivo,
          usuario:  this.cancelamento.dados.usuario
        }

        try {
          await this.$http.post(`/api/protected/gestaoCompra/cancelar`, body)
        } catch(err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
          return
        }

        await this.$store.dispatch('compra/GERAR_LISTA')
        this.$refs['modal-cancelamento'].hide()
        Tools.exibirMensagem(this.$store, 'Aviso', 'success', 'Compra cancelada com sucesso!' )
        
      } finally {
       this.$store.commit('controle/setAguardando', false) 
      }
    },
    
    async showMsgDevolver(item) {
      this.$store.commit("compra/SET_REGISTRO_SELECIONADO_ID",item.ID)
      const resposta = await this.$bvModal.msgBoxConfirm(`Devolver para o terminal de Expedição o Pedido: ${item.ID} Do Cliente: ${item.NOME_CLIENTE} ?`, {
        title: 'Devolver?',
        size: 'lg',
        buttonSize: 'lg',
        okVariant: 'primary',
        okTitle: 'SIM',
        cancelTitle: 'NAO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      
      if (resposta == false) {
        return
      }
      let body = {
        vendaId: item.ID,
        usuario: window.localStorage.getItem('login')
      }
      try {
        this.$store.commit('controle/setAguardando', true) 
        try {
          await this.$http.post( `/api/protected/vendapedido/devolverExpedicao`, body)
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
          return
        }
        await this.$store.dispatch('compra/GERAR_LISTA')
        Tools.exibirMensagem(this.$store, 'Aviso', 'success', 'Sucesso' )
        
      } finally {
        this.$store.commit('controle/setAguardando', false) 
      }
    },
    async abrirModalCancelamento(item) {
      // Resetar permissao a cada abertura do modal para evitar estado residual
      this.cancelamento.parametros.permissao = false
      this.cancelamento.parametros.processando = false
      this.cancelamento.parametros.busy = false

      try {
        this.$store.commit('controle/setAguardando', true)

        // Valida no backend se status permite cancelar
        try {
          await this.$http.get(`/api/protected/gestaoCompra/getPermiteAlterar/${item.ID}`)
        } catch(err)  {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
          return
        }

        this.cancelamento.dados.titulo = item.N_VENDA || item.NUMERO_EXTERNO || ''
        this.cancelamento.dados.id = item.ID
        this.cancelamento.dados.nomeCliente = item.NOME_FORNECEDOR || item.NOME_CLIENTE || ''
        this.cancelamento.dados.documento = item.N_VENDA || item.NUMERO_EXTERNO || ''
        this.cancelamento.dados.motivo = ''
        this.cancelamento.dados.dataVencimento = Tools.formatarDataBR(item.DT_PEDIDO)
        this.cancelamento.dados.valorDocumento = this.formatCurrency(item.VL_PEDIDO)
        this.cancelamento.dados.usuario = window.localStorage.getItem('login')

        this.$store.commit("compra/SET_REGISTRO_SELECIONADO_ID", item.ID)

        // Compra CONCLUIDA (OP_STATUS = '2') → exige permissão especial para cancelar
        const statusAtual = String(item.OP_STATUS || '').trim()
        if (statusAtual === '2') {
          const usuario = window.localStorage.getItem('login')
          let permissaoResult = false
          try {
            permissaoResult = await this.$http.get(`/api/protected/usuario/consultarpermissao?usuario=${usuario}&permissao=AcPropExcluirVendas`)
          } catch (err) {
            Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
            return
          }

          if ((permissaoResult.data == false) || (permissaoResult.data === 'false')) {
            Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Usuário sem permissão para cancelar compras concluídas!' )
            return
          }
        }

        this.cancelamento.parametros.permissao = true
        this.cancelamento.parametros.processando = false
        this.cancelamento.parametros.busy = true
        this.$refs['modal-cancelamento'].show()
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    focusModalCancelamento() {
      this.$refs.motivoCancelamento.focus()
    },
    limpar() {
      this.$store.commit("compra/SET_LIMPAR", null)
    },
    selecionarLinha(item) {
      this.$store.commit("compra/SET_REGISTRO_SELECIONADO_ID", item.ID)
    },
    rowClassSelecionado(item, type) {
      if (type !== 'row' || !item) return ''
      const selId = this.$store.getters['compra/REGISTRO_SELECIONADO_ID']
      return item.ID === selId ? 'cec-row-selected' : ''
    },
    traduzirOP_XML(item) {
      let valor = item?.trim()
      switch (valor) {
        case '0':
          return 'XML/NAO'
        case '1':
          return 'XML/DIVG'
        case '2':
          return 'XML/VINC'  
        case '3':
          return 'XML/CONFR'  
        default:
          return ''
      }
    },
    colorirOP_XML(item) {
      let valor = item?.trim()
      switch (valor) {
        case '0':
          return 'yellow'
        case '1':
          return 'red'
        case '2':
          return 'info'  
        case '3':
          return 'success'  
        default:
          return ''
      }
    },
    traduzirOP_GERA_ESTOQUE(item) {
      let valor = item?.trim()
      switch (valor) {
        case 'S':
          return 'EST/SIM'
        case 'N':
          return 'EST/NAO'
        default:
          return ''
      }
    },
    colorirOP_GERA_ESTOQUE(item) {
      let valor = item?.trim()
      switch (valor) {
        case 'S':
          return 'success'
        case 'N':
          return 'secondary'
        default:
          return ''
      }
    },
    traduzOP_TIPO_PEDIDO(tipoPedido) {
      let valor = tipoPedido?.trim()
      switch (valor) {
        case 'I':
          return 'INDUS'
        case 'A':
          return 'ALMOX'
        default:
          return ''
      }
    },
    colorirOP_TIPO_PEDIDO(tipoPedido) {
      let valor = tipoPedido?.trim()
      switch (valor) {
        case 'I':
          return 'info'
        case 'A':
          return 'primary'
        default:
          return ''
      }
    },
    traduzirNF(valor) {
      switch (valor) {
        case 0:
          return 'NFN'
        case 1:
          return 'NFP'
        case 2:
          return 'NFE'
        default:
          return ''
      }
    },
    colorirNF(valor) {
      switch (valor) {
        case 0:
          return 'secondary'
        case 1:
          return 'warning'
        case 2:
          return 'success'
        default:
          return ''
      }
    },
    formatCurrency(value) {
      if (value === null || value === undefined) return 'R$ 0,00';
      const numericValue = typeof value === 'string' ? parseFloat(value.replace(',', '.')) : value;
      if (isNaN(numericValue)) return 'R$ 0,00';
      return numericValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    formatDecimal(value, precision = 2) {
      if (value === null || value === undefined) return (0).toFixed(precision).replace('.', ',');
      const numericValue = typeof value === 'string' ? parseFloat(value.replace(',', '.')) : value;
      if (isNaN(numericValue)) return (0).toFixed(precision).replace('.', ',');
      return numericValue.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: precision });
    },
    traduzirOP_FINANCEIRO(valor) {
      switch (valor) {
        case '0':
          return 'FIN.A'
        case '1':
          return 'FIN.F'
        case '2':
          return 'FIN.N'  
        default:
          return ''
      }
    },
    colorirOP_FINANCEIRO(valor) {
      switch (valor) {
        case '0':
          return 'warning'
        case '1':
          return 'success'
        case '1':
          return 'secondary'  
        default:
          return ''
      }
    },
    traduzirAlterado(valor) {
      switch (valor) {
        case '0':
          return 'ORI'
        case '1':
          return 'ALT'
        default:
          return ''
      }
    },
    colorirAlterado(valor) {
      switch (valor) {
        case 0:
          return 'success'
        case 1:
          return 'warning'
        default:
          return ''
      }
    },
    traduzirOrigem(valor) {
      switch (valor) {
        case '0':
          return 'PRE'
        case '1':
          return 'PED'
        case '2':
          return 'SER'  
        default:
          return ''
      }
    },
    colorirOrigem(valor) {
      switch (valor) {
        case '0':
          return 'secondary'
        case '1':
          return 'info'
        case '2':
          return 'warning'  
        default:
          return ''
      }
    },
    colorirFormaPagto(valor) {
      return ''
    },
    traduzirFormaPagto(valor) {
      if (valor === 'V') return 'A VISTA'
      else if (valor === 'P') return 'A PRAZO'
      else ''
    },
    colorirStatus(situacao) {
      let retorno
      const valor = situacao?.trim()
      switch (valor) {
        case '0' :
          retorno = 'danger'
          break;
        case '1':
          retorno = 'warning'
          break;
        case '2':
          retorno = 'success'
          break;
        case '3':
          retorno = 'info'
          break;      
      
        default:
          break;
      }
      return retorno
      
    },
    traduzirSituacao(situacao) {
      let retorno
      const valor = situacao?.trim()
      switch (valor) {
        case '0' :
          retorno = 'CANCELADO'
          break;
        case '1':
          retorno = 'CADASTRANDO'
          break;
        case '2':
          retorno = 'CONCLUIDO'
          break;
        case '3':
          retorno = 'DEVOLVIDO'
          break;      
      
        default:
          break;
      }
      return retorno
    },
    details (item) {
      alert(JSON.stringify(item.item.ID))
    },
    async edit (item) {
      if (!item.ID) {
        return
      }
      /*
      this.$store.commit('controle/setAguardando', true)
      try {
        this.registroSelecionadoId = item[0].ID
        await this.$http.get(`/api/protected/compra/getPermiteAlterar/${item[0].ID}`)
      } catch(err) {
        this.$store.commit('controle/setAguardando', false)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
        return
      }
        */

      this.$store.commit("compra/SET_REGISTRO_SELECIONADO_ID", item.ID)
      this.$router.push(`/movimentos/compras/edit/${item.ID}`)
    },
    novo () {
      this.$store.commit("compra/SET_REGISTRO_SELECIONADO_ID", null)
      this.$router.push(`/movimentos/compras/add`)
    },
    async pesquisar () {
      if (this.modalConfirmacaoAberto) {
        return;
      }
      this.$store.commit("compra/SET_REGISTRO_SELECIONADO_ID", null)
      
      this.status = false
      // ✅ Usa apenas flag local (não usa setAguardando)
      this.isBusy = true
      try {
        const result = await this.$store.dispatch('compra/GERAR_LISTA')
        
        if (result.needsConfirmation) {
          this.isBusy = false
          this.resultadoPendenteCount = result.count
          this.$refs.modalConfirmarResultadoGrande.show()
          return
        }
        
        this.status = true
      } catch (error) {
        this.status = false
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Falha ao pesquisar: ' + error.message)
      } finally {
        // ✅ Só mexe em flag local
        this.isBusy = false
      }
    },
    async confirmarCarregarResultadoGrande() {
      // ✅ Usa apenas flag local
      this.isBusy = true
      try {
        await this.$store.dispatch('compra/GERAR_LISTA', { skipConfirmation: true })
        this.status = true
        this.resultadoPendente = null
        this.resultadoPendenteCount = 0
      } catch (error) {
        this.status = false
        Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Falha ao carregar os registros: ' + error.message)
      } finally {
        // ✅ Só mexe em flag local
        this.isBusy = false
      }
    },
    cancelarCarregarResultadoGrande() {
      this.resultadoPendente = null
      this.resultadoPendenteCount = 0
      Tools.exibirMensagem(this.$store, 'Informação', 'info', 'Carregamento de resultado grande cancelado')
    },
    async imprimirEspelho(id) {
      if (!id) return
      
      try {
        this.$store.commit('controle/setAguardando', true)
        const response = await this.$http.get(`/api/protected/relatorios/espelhoCompra/${id}`)
        
        if (response.data) {
          await imprimirEspelhoCompra(response.data, localStorage.getItem('nomeusuario'))
        } else {
          Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Não foi possível obter os dados da compra.')
        }
      } catch (err) {
        console.error(err)
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Falha ao gerar espelho da compra.')
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async imprimir (id) {
      try {

        try {
          this.$store.commit("compra/SET_REGISTRO_SELECIONADO_ID", id)
          
          // Questionar sobre a Solicitação de Débito
          const resposta = await this.$bvModal.msgBoxConfirm('Deseja exibir a Solicitação de Débito no relatório?', {
            title: 'Imprimir Solicitação de Débito',
            size: 'md',
            buttonSize: 'md',
            okVariant: 'primary',
            okTitle: 'SIM',
            cancelTitle: 'NÃO',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
          })
          
          this.$store.commit('controle/setAguardando', true)

          const payload = {
            id: id,
            login: window.localStorage.getItem('login'),
            imprimeResumo: resposta === true
          } 

          let uri = '/api/protected/relatorios/relCompra'
          const response =  await this.$http.post(uri, payload, {responseType: 'arraybuffer'})
          
          const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
          const link = document.createElement('a')
          
          link.href = url
          link.setAttribute('download', 'relCompra.pdf') 
          link.download = 'relCompra.pdf'
          const janela = window.open(link)
          janela.onload = function(){
            setTimeout(() => {
              janela.document.title = id +' Relatório de Compras'
            }, 2000);
          }

          Tools.exibirMensagem(this.$store, 'Aviso', 'success', 'Relatório Gerado com Sucesso!!!' )
        } catch(err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Relatório Indisponível!!!' )
        }
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async imprimirPesagem (id) {
      try {
        this.$store.commit("compra/SET_REGISTRO_SELECIONADO_ID", id)
        this.$store.commit('controle/setAguardando', true)

        const payload = {
          id: id,
          login: window.localStorage.getItem('login')
        }

        const uri = '/api/protected/relatorios/relCompraPesagemResumo'
        const response = await this.$http.post(uri, payload, {responseType: 'arraybuffer'})
        
        const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
        const link = document.createElement('a')
        
        link.href = url
        link.setAttribute('download', 'relCompraPesagem.pdf') 
        link.download = 'relCompraPesagem.pdf'
        const janela = window.open(link)
        janela.onload = function(){
          setTimeout(() => {
            janela.document.title = id + ' Relatório de Pesagem - Expedição'
          }, 2000);
        }

        Tools.exibirMensagem(this.$store, 'Aviso', 'success', 'Relatório de Pesagem Gerado com Sucesso!!!' )
      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Relatório de Pesagem Indisponível!!!' )
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    handleKeydown(event) {
      if (event.key === "Insert") {
        // Simula o clique no botão quando a tecla Insert for pressionada
        this.novo()
      }
      if (event.key === "Enter") {
        // Aplica o filtro quando Enter for pressionada
        event.preventDefault()
        this.pesquisar()
      }
    }
  },
  async created () {
    // ✅ Pesquisa apenas se a lista estiver vazia
    // (primeira vez ou acesso direto)
    // Quando vem do cadastro, dados já estão atualizados na store
    const listagem = this.$store.getters['compra/LISTA']
    if (!listagem || listagem.length === 0) {
      await this.pesquisar()
    }
  },
  async mounted () {
    setTimeout(() => {
      document.addEventListener("keydown", this.handleKeydown);
    }, 200)

    this.$nextTick(() => {
      if (this.$refs.dt1) {
        if (typeof this.$refs.dt1.focus === 'function') this.$refs.dt1.focus()
        else if (this.$refs.dt1.$el) this.$refs.dt1.$el.focus()
      }
    })
  },
  beforeDestroy() {
    // Remove o evento de keydown ao destruir o componente
    document.removeEventListener("keydown", this.handleKeydown);
  },
  watch: {
    'dadosModalNotaFiscal.tipoMovimentacaoId': async function (val, oldVal) {
      if (!val) return
      if (val && !oldVal) return

      
      const tipoMov = this.dadosModalNotaFiscal.tipoMovimentacoes.items.filter(item =>
        item.ID === oldVal
      )
      
      this.dadosModalNotaFiscal.cfopId = tipoMov?.[0].CFOP_ID
      this.dadosModalNotaFiscal.textoId = tipoMov?.[0].TEXTO_NFE_ID

    },
    'dadosModalNotaFiscal.textoId': async function (val, oldVal) {
      if (!val) return
      if (val && !oldVal) return

      
      const texto = this.dadosModalNotaFiscal.textos.items.filter(item =>
        item.ID === oldVal
      )
      
      this.dadosModalNotaFiscal.obsContribuinte = texto?.[0].TEXTO

    }
  }
}
</script>

<style>
/********************************CABECALHO FIXO***********************/

/* Cabeçalho sticky — cobre com e sem .table-responsive */
.b-table-sticky-header > .table.b-table > thead > tr > th,
.b-table-sticky-header .table-responsive > .table.b-table > thead > tr > th {
  position: sticky !important;
  top: 0;
  z-index: 2;
  background-clip: padding-box;
}

/* Evita “vazar” borda quando sticky 
.b-table-sticky-header > .table.b-table,
.b-table-sticky-header .table-responsive > .table.b-table {
  border-collapse: separate;
}
*/
/* Faz o wrapper responsivo rolar verticalmente respeitando a altura calculada */
.b-table-sticky-header .table-responsive {
  max-height: inherit;   /* pega o max-height do contêiner sticky */
  overflow-y: auto;      /* cria rolagem interna da tabela */
}

/* Colunas fixas (stickyColumn) também com wrapper responsivo */
.table.b-table th.b-table-sticky-column,
.table.b-table td.b-table-sticky-column,
.b-table-sticky-header .table-responsive .table.b-table th.b-table-sticky-column,
.b-table-sticky-header .table-responsive .table.b-table td.b-table-sticky-column {
  z-index: 3;
}

/* Destaca a linha selecionada (vence striped/dark e aplica nos <td>) */
.table.b-table tbody tr.cec-row-selected,
.table.b-table tbody tr.cec-row-selected > td {
  background-color: #c2cfd6  !important;
  color: #000000 !important;
}

/* Links/ícones continuam visíveis */
.table.b-table tbody tr.cec-row-selected a {
  color: #000000 !important;
}

/* Colunas sticky também pintadas */
.table.b-table tbody tr.cec-row-selected td.b-table-sticky-column {
  background-color: #c2cfd6  !important;
}

/* (opcional) hover da linha já selecionada */
.table.b-table tbody tr.cec-row-selected:hover > td {
  background-color: #c2cfd6  !important;
}


/* Layout do bloco Callout */
.callout { padding: .05rem .5rem; }
.callout-row {
  display: flex;
  align-items: center;
  gap: .5rem;
}

/* Caixa do gráfico com tamanho fixo */
.cec-chart-box {
  width: 140px;      /* ajuste se quiser maior/menor */
  height: 40px;      /* combina com :height do componente */
  display: flex;
  align-items: center;
}

/* Faz o canvas preencher a caixa */
.cec-chart-box canvas {
  width: 100% !important;
  height: 100% !important;
}

/* Regras para evitar problemas de posicionamento nos gráficos */
.callout .cec-chart-wrapper { position: static; left: auto; top: auto; float: none; width: auto; }
.cec-chart-wrapper canvas { width: auto !important; }

/* premium styles */
.modal-header-premium {
  border-bottom: none;
  position: relative;
}

.header-icon-wrapper {
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 1.5rem;
}

.bg-white-10 {
  background-color: rgba(255, 255, 255, 0.1);
}

.modal-section-title {
  font-size: 0.9rem;
  font-weight: 700;
  color: #2d3748;
  border-bottom: 2px solid #edf2f7;
  padding-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.modal-label-premium {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #6c757d;
  margin-bottom: 0.4rem;
  display: block;
}

.shadow-xs {
  box-shadow: 0 2px 4px rgba(0,0,0,0.05) !important;
}

/* Table Enhancements */
.table-finance thead th {
  background-color: #f8f9fa !important;
  text-transform: uppercase;
  font-size: 0.7rem;
  font-weight: 700;
  color: #495057;
  letter-spacing: 0.5px;
  border-top: none !important;
  border-bottom: 2px solid #dee2e6 !important;
  padding: 12px 8px !important;
}

.table-finance tbody td {
  vertical-align: middle !important;
  padding: 10px 8px !important;
  color: #4a5568;
}

.table-finance tr:hover {
  background-color: rgba(66, 153, 225, 0.05) !important;
}

.table-finance thead th {
  background-color: #f8f9fa !important;
  text-transform: uppercase;
  font-size: 0.7rem;
  font-weight: 700;
  color: #495057;
  letter-spacing: 0.5px;
  border-top: none !important;
  border-bottom: 2px solid #dee2e6 !important;
  padding: 12px 8px !important;
}

.table-finance tbody td {
  vertical-align: middle !important;
  padding: 10px 8px !important;
  color: #4a5568;
}

.btn-soft-primary {
  background-color: rgba(32, 168, 216, 0.1);
  color: #20a8d8;
  border: none;
}
.btn-soft-primary:hover {
  background-color: #20a8d8;
  color: white;
}

.btn-soft-danger {
  background-color: rgba(248, 108, 107, 0.1);
  color: #f86c6b;
  border: none;
}
.btn-soft-danger:hover {
  background-color: #f86c6b;
  color: white;
}

.bg-soft-warning { background-color: rgba(255, 193, 7, 0.12) !important; }
.bg-soft-success { background-color: rgba(40, 167, 69, 0.12) !important; }
.bg-soft-danger { background-color: rgba(220, 53, 69, 0.12) !important; }

.modal-footer-premium {
  background-color: #f8f9fa;
  border-top: 1px solid #edf2f7;
}

.list-header-premium {
  background: white;
  border-bottom: 1px solid #e2e8f0;
  padding: 1.5rem 2rem;
  margin-bottom: 1rem;
  border-radius: 1rem;
}

.card-filter-premium {
  border: none;
  border-radius: 16px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  background: #fdfdfd;
}

.btn-icon-only {
  width: 38px;
  height: 38px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}

</style>



// WEBPACK FOOTER //
// src/views/movimentos/compras/ComprasListagem.vue